import { useUser } from '@/contexts/UserSession';

const useGlossaryAbilities = () => {
    const user = useUser(true);
    const company = user.__typename === 'TenantUser' ? user.company : null;

    const canViewGlossary = () => {
        return !!company?.id;
    };

    const canManageGlossary = () => {
        return false;
    };

    const displayGlossaryMenuItem = () => {
        return canViewGlossary();
    };

    return {
        canViewGlossary,
        canManageGlossary,
        displayGlossaryMenuItem,
    };
};

export type GlossaryAbilities = ReturnType<typeof useGlossaryAbilities>;
export default useGlossaryAbilities;
